import { Flex } from '@components/gassan-ui'
import { Text } from '@components/gassan-ui/Typography/Text'
import { formatPrice } from '@lib/formatPrice'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type Props = {
  price: number
}

const CartPrivilegeItemListPrice: FC<Props> = ({ price }) => {
  const { t } = useTranslation(['other', 'checkout'])
  return (
    <Flex
      flexDirection={['row', 'column']}
      justifyContent={['flex-start', 'flex-start']}
      alignItems={['center', 'flex-end']}
      position="relative"
      mb="1rem"
    >
      <>
        <Text
          as="span"
          className="mb-1 mr-2 sm:mr-0"
          variant="regular"
          style={{ textDecoration: 'line-through' }}
        >
          {formatPrice(price, true)}
        </Text>
        <Text variant="regular-bold" className="mb-1" as="span">
          {t('free', { ns: 'other' })}
        </Text>
        <Text className="mb-2 hidden sm:block" as="span">
          {t('privilege', { ns: 'checkout' })}
        </Text>
      </>
    </Flex>
  )
}

export default CartPrivilegeItemListPrice
